<template>
    <div class="auth-info auth-info-login">
        <img :src="logoImg" alt="" class="logo-img">
        <p class="auth-title">已授权</p>
        <div class="user-content">
            <div class="field-list">
                <span>蜜蜂账号：</span>
                <span>{{authData.beesAccount}}</span>
            </div>
            <div class="field-list">
                <span>库存100账号：</span>
                <span>{{authData.stock100Account}}</span>
            </div>
            <div class="field-list">
                <span>授权时间：</span>
                <span>{{authData.authTime}}</span>
            </div>
        </div>
        <bigBtn :txt="'解绑'" @onBtnClick="onBtnClick"></bigBtn>
        <p class="auth-tip">解绑后将无法查看库存100对应门店的订单</p>
    </div>
</template>

<script>
import http from "@/utils/axios"; 
import utils from "@/utils/common";
import { getBeeOrigin } from "@/utils/util";
import bigBtn from './bigBtn'
import './auth.less';
export default {
    props: {
        authData: {
            type: Object,
            default: function() {
                return {}
            }
        }
    },
    data() {
        return {
            logoImg: require('../../../assets/order/icon-logo.png')
        }
    },
    methods: {
        onBtnClick() {
            this.$dialog.confirm({
                title: "解绑",
                message: '解绑后将无法对库存100订单\n进行发货操作',
                confirmButtonColor: '#007AFF',
                className: "auth-dialog"
            }).then(()=>{
                this.unbind()
            })
        },
        unbind() {
            http({
                url: '/order/bees/bees/stock100/unbindAuthorization',
                method: 'post'
            })
            .then(rps=>{
                if(rps.code == 200) {
                    utils.nativeMethod({tm: 1010101, tp: {tm: "3080300,3080400"}})
                    utils.nativeMethod({tm: 1010200, tp: { url: getBeeOrigin() + '/auth', params: JSON.stringify(rps.data),finishPage:1}})
				    // utils.finishPage();
                }
            })
        }
    },
    components: {
        bigBtn
    }
}
</script>